module.exports = __webpack_public_path__ + "img/logo_white_500.6fb8a623.png";